import React, { useState } from 'react'
import createGroupPhoto from './lineImg/12813.jpg'
import addLineGroup from './lineImg/12812.jpg'
import LNWeb from './lineImg/LNweb.PNG'
import Login from './lineImg/Login.PNG'
import Aouth from './lineImg/Aouth.PNG'
import ahref from './lineImg/ahref.png'
import selcGrp from './lineImg/selectGroup.PNG'
import generAouth from './lineImg/generAouth.PNG'

const Introduction =(props)=>{
    
    // start !!!!
    const [start, setStart] = useState(true);
    
    // part1
    const [partOneGroup, setPartOneGroup] = useState(false);

    // after line notify login
    const [LineNotifyLogin, setLineNotifyLogin] = useState(false);

    // 發行權杖
    const [generateAouth, setGenerateAouth] = useState(false);

    return(
    <div className="pos-f t-0 r-0 margt-s w-50 h-80 bg-white br-20 fx-d-c margr-xs shadow pad-5 l b t r" onClick={e=>e.stopPropagation()}>
        {/* <div className='margt-m'></div> */}
        <div className='w-100 h-10 fx-d-r'>
            <div className='w-90 font-xl fx-ccc'>Line notify 權杖取得教學</div>
            <div className="w-10 h-100 fx-nfen" onClick={props.hide}>
                <div className="cross br-10 forAdmin dark fx-ccc cursor pt"></div>
            </div>
        </div>
        <div className='w-100 h-90'>
            <div className='w-100 fx-d-c h-20 margb-xs'>
                <div className='h-60 fx-d-r fx-ccc'>
                    <div className='w-10 fx-ccc'><div className={`dash_bdr rad fx-ccc ${ props.lineGroup? "solid":"dotted"}`}>1</div></div>
                    <div className='w-15 fx-ccc'><div className='dash_bdr dotted h-0 w-100'></div></div>
                    <div className='w-10 fx-ccc'><div className={`dash_bdr rad fx-ccc ${ generateAouth? "solid":"dotted"}`}>2</div></div>
                    <div className='w-15 fx-ccc'><div className='dash_bdr dotted h-0 w-100'></div></div>
                    <div className='w-10 fx-ccc'><div className={`dash_bdr rad fx-ccc ${ false? "solid":"dotted"}`}>3</div></div>
                </div>
                <div className='fx-d-r fx-ccc'>
                    <div className='w-25 fx-ccc '>創建 Line 群組</div>
                    <div className='w-25 fx-ccc '>登入 Line Notify 服務</div>
                    <div className='w-25 fx-ccc '>取得權杖</div>
                </div>
            </div>
            <div className='w-100 h-70 pad-30 l r'>
                {start? <>
                    <div className='margt-m'>本功能將會讓您能透過手機應用程式 Line 收到美維智慧床墊的警訊通知。</div>
                    <div>以下步驟將帶您一步步完成設定，過程約需3分鐘。</div>
                    <div className='margb-m'>請準備好您的手機。</div>
                    <div className='w-100 fx-ccc h-40'>
                        <div onClick={()=>{setStart(false); setPartOneGroup(true)}} className='margb-xs shadow-xs bgLG h-40 br-10 w-20 fx-ccc margt-xs cursor pt'>好的!開始!</div>
                    </div>
                </>:null }

                {partOneGroup?<>
                    <div className='font-l margb-xs'>創建專用 Line 群組</div>
                    <div>透過您的 Line App 或 Line 桌面應用程式創建群組。</div>
                    <div>並加入將同樣會需要收到床墊警訊通知的好友加入此群組。</div>
                    <img src={createGroupPhoto} className='w-40' alt='create group' />
                    <img src={addLineGroup} className='w-40 margl-xs' alt='create group' />
                    <div className='margb-xs shadow-xs h-10 bgLG br-10 w-20 fx-ccc margt-xs cursor pt' 
                        onClick={()=>{
                            props.setLineGroup(true); 
                            setPartOneGroup(false)
                            setLineNotifyLogin(true)
                            }}>我創建好群組了!</div>
                </>:null}

                {LineNotifyLogin? <div className='overflow-y-scroll h-100'>
                    <div className='font-l'>登入Line Notify 服務</div>
                    <div className='margb-xs'>Line Notify 服務將為我們發送床墊警訊。</div>
                    <div className='fx-d-r w-100 fx-fsc'>
                        <a href='https://notify-bot.line.me/zh_TW/' className='w-30' target='_blank' rel="noopener noreferrer" title='前往line notify'>
                            <img src={ahref} alt='Line Notify Web' className='w-100 crisp-img br-20 shadow-s'/>
                        </a>
                        <a href='https://notify-bot.line.me/zh_TW/' className='margl-s' target='_blank' rel="noopener noreferrer" title='前往line notify https://notify-bot.line.me/zh_TW/'>點我將前往 Line Notify</a>
                    </div>
                    <div className='margt-s'>1. 進入 Line Notify 服務官方網站，點選右上角 "登入"</div>
                    <img src={LNWeb} alt='Line Notify Web' className='w-60 crisp-img br-20'/>
                    <div className='margt-xs'>2. 透過您的 Line 帳號登入</div>
                    <img src={Login} alt='Line Notify Login' className='w-60 crisp-img br-20'/>
                    
                    <div className='margb-xs shadow-xs h-10 bgLG br-10 w-20 fx-ccc margt-xs cursor pt' 
                        onClick={()=>{
                            setLineNotifyLogin(false)
                            setGenerateAouth(true)
                            }}>我登入了!</div>
                </div>:null}
                {generateAouth?<div className='overflow-y-scroll h-100'>
                    <div className='font-l'>取得權杖</div>
                    <div className='margt-xs'>1. 點選發行權杖</div>
                    <img src={Aouth} alt='press Generate Aouth' className='w-60 crisp-img br-20 crispy-img shadow-s-noHover'/>
                    <div className='margt-s'>2. 替Line Notify取名，並選擇剛才所建立的群組</div>
                    <img src={selcGrp} alt='Line Notify Generate Aouth' className='w-50 crisp-img br-20 crispy-img shadow-s-noHover'/>
                <div className='margt-s'>3. 權杖生成成功! 此權杖只會生成一次，記得複製起來!</div>
                    <img src={generAouth} alt='Aouth' className='w-50 crisp-img br-20 crispy-img shadow-s-noHover'/>
                <div className='margb-xs shadow-xs h-10 bgLG br-10 w-20 fx-ccc margt-xs cursor pt' 
                    onClick={()=>{
                        props.setAouthInput(true)
                        props.hide()
                        }}>權杖複製起來了!</div>
                </div>:null}
            </div>               
        </div> 
    </div>
    );	

}
export default Introduction;